exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\r\n.GIS_Client #mapstore-layer-settings {\r\n    min-width: 400px;\r\n}\r\n\r\n.GIS_Client .portal-dialog {\r\n    position: absolute;\r\n}\r\n\r\n@media all and (min-width: 635px) {\r\n    .GIS_Client .portal-dialog {\r\n        left: calc(50% - 315px);\r\n        top: 100px;\r\n        max-width: 630px;\r\n        background-color: #fff;\r\n    }\r\n}\r\n\r\n@media all and (max-width: 634px) {\r\n    .GIS_Client .portal-dialog {\r\n        width: 100%;\r\n    }\r\n}\r\n", ""]);

// exports
